import { CHCconnectwithusform } from './connect-with-us-form.component.js';
export { CHCconnectwithusform };

customElements.define('chcapp-connect-with-us-form', CHCconnectwithusform);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-connect-with-us-form': CHCconnectwithusform;
  }
}
